module.exports = __webpack_public_path__ + "static/media/event-5.77d417f9.png";